var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5665 21.25C19.992 21.25 21.9581 19.3473 21.9581 17C21.9581 14.6527 19.992 12.75 17.5665 12.75C15.141 12.75 13.1748 14.6527 13.1748 17C13.1748 19.3473 15.141 21.25 17.5665 21.25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.725 14.7269L27.1181 10.9718L29.2777 8.50004L26.35 5.66671L23.8097 7.76755L19.8471 6.19051L18.9358 2.83337H16.0749L15.1499 6.23498L11.2784 7.81432L8.78329 5.66671L5.85551 8.50004L7.98308 11.0342L6.40081 14.799L2.92773 15.5834V18.4167L6.44269 19.3453L8.0744 23.0913L5.85551 25.5L8.78329 28.3334L11.4053 26.2655L15.22 27.7841L16.1027 31.1667H19.0305L19.9154 27.7854L23.7956 26.2303C24.4424 26.6777 26.35 28.3334 26.35 28.3334L29.2777 25.5L27.1052 23.02L28.7125 19.2639L32.2054 18.3844L32.2055 15.5834L28.725 14.7269Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings_icon.60f6f382affff0413dff7eb894ba903d.svg";
export { ForwardRef as ReactComponent };